<template>
  <div class="student-list">
    <div class="table">
      <div class="table__row row-header">
        <div class="table-col col-header-name">Имя</div>
        <div class="table-col">Неявка</div>
        <div class="table-col">Оценка</div>
      </div>
      <div
        class="table__row"
        v-for="(student, index) of students"
        :key="`student-${index}`"
      >
        <div class="table__col col-name">{{ student.name }}</div>
        <div class="table__col col-absence">
          <span class="table__col-desc">Неявка</span>
          <el-checkbox
            :key="`student-${index}-absence-${student.absence}`"
            :value="Boolean(student.absence)"
            @change="$emit('update-student', { field: 'absence', id: student.id, value: +$event })"
          >
          </el-checkbox>
        </div>

        <div class="table__col col-result">
          <span class="table__col-desc">Оценка</span>
          <el-select
            :key="`student-${index}-result-${student.result}`"
            :disabled="Boolean(student.absence)"
            :value="student.result"
            placeholder="Выберите оценку"
            @change="$emit('update-student', { field: 'result', id: student.id, value: $event })"
          >
            <el-option
              v-for="(item, index) in results"
              :key="index"
              :value="item.id"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "studenstList",

  props: {
    results: {
      type: Array,
      default: () => ({})
    },

    students: {
      type: Array,
      default: () => ({})
    }
  },
};
</script>

<style lang="scss">
.student-list {
  .table {
    color: $regular-text-clr;
    width: 100%;
    display: block;
    overflow: visible;

    &__row {
      width: 100%;
      display: grid;
      grid-template-columns: auto 100px 200px;
      grid-template-rows: auto;
      align-items: center;
      justify-items: center;
      border-bottom: 1px solid $base-border-clr;
      padding: 10px;
      grid-template-areas: "name absence result";
    }
    .row-header {
      .table-col {
        font-weight: bold;
      }
    }
    .table__col-desc {
      display: none;
      color: $regular-text-clr;
    }
    .col-header-name {
      justify-self: start;
    }
    .col-name {
      justify-self: start;
      grid-area: name;
    }

    .col-absence {
      grid-area: absence;
    }
    .col-result {
      grid-area: result;
    }
  }
}
@media (max-width: 400px) {
  .student-list {
    .table {
      &__row {
        justify-items: center;
        grid-template-columns: 1fr 30px 1fr;
        grid-template-areas:
          "name name name"
          "absence . result";
      }
      .table__col {
        text-align: center;
      }
      .table__col-desc {
        align-self: start;
        display: block;
        margin-bottom: 10px;
      }
      .el-checkbox {
        align-self: center;
      }
      .row-header {
        display: none;
      }
      .col-name {
        justify-self: center;
        padding: 8px;
      }

      .col-absence {
        justify-self: center;
        height: 100%;
      }
      .col-result {
      }
    }
  }
}
</style>